<template>
  <div class="container">
    <Header @changeStatus="changeStatus"></Header>
   
    <!-- 我的店铺 -->
    <div class="my_store" v-if="my_shop.length > 0">
      <div class="w1200">
        <h5 class="tit">我的店铺</h5>
        <ul>
          <li
            v-for="(item, index) in my_shop"
            :key="index"
            @click="toSystem(item)"
          >
            <div class="icon">
              <img :src="item.product_small_pic" alt />
            </div>
            <h6>{{ item.product_title }}</h6>
            <div class="info">
              <span>{{ item.version_text }}</span>
              <em></em>
              <span class="time" v-if="parseInt(item.expire_days) <= 0"
                >已到期</span
              >
              <span class="time" v-else>{{ item.expire_days_text }}</span>
            </div>
            <div class="del" @click.stop="delshop(item)">删除</div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 我的店铺 -->
    <!-- 产品列表 -->
    <template v-for="(item, index) in product_list">
      <div
        class="all_edition w1200"
        :key="index"
        v-if="index + 2 == status || status == 1 || !status"
      >
        <h5 class="tit">{{ item.one_class_title }}</h5>
        <ul>
          <li
            :class="index == activeLi[0] && subindex == activeLi[1] ? 'on' : ''"
            v-for="(subitem, subindex) in item.product"
            :key="subindex"
            @mouseenter="productHover(index, subindex)"
            @mouseleave="productLeave"
          >
            <div class="top">
              <p>{{ subitem.product_title }}</p>
              <img :src="subitem.product_small_pic" alt />
            </div>
            <div class="desc">
              <div class="textbox">
                <p>{{ subitem.product_desc }}</p>
              </div>
            </div>
            <div class="bt" @click="createSystemTip(subitem)" v-if="subitem.can_create&&!subitem.is_buy">
              <span>立即创建</span>
              <img src="../public/images/arr.png" alt />
            </div>
            <div
              class="bt"
              @click="createSystem(subitem)"
              v-if="!subitem.can_create&&!subitem.is_buy"
            >
              <span>敬请期待</span>
              <img src="../public/images/arr.png" alt />
            </div>
            <div class="bt" @click="toSystem(subitem)" v-if="subitem.is_buy">
              <span>立即查看</span>
              <img src="../public/images/arr.png" alt />
            </div>
          </li>
        </ul>
      </div>
    </template>
    <CreateShop :dialogCreateShop="dialogCreateShop" :product="curPro" @close="createSystemTipClose" @createSystem="createSystem"></CreateShop>
  </div>
  
</template>

<script>
import Header from "./header";
import CreateShop from "./createShop.vue";
import {
  productList,
  createSystem,
  initShop,
  delShop,
} from "../public/js/api.js";
export default {
  data() {
    return {
      status: 1,
      dialogCreateShop: false,
      formLabelWidth: '120px',
      curPro: {},
      product_list: [],
      my_shop: [],
      activeLi: [],
      
    };
  },
  methods: {
    // 切换列表
    changeStatus(n) {
      this.status = n;
    },
    async getlist() {
      let res = await productList();
      if (res.code != 1) {
        this.$message.error(res.msg);
        return;
      }
      // if (res.data.product_list[0].product[2].id == 29) {
      //   res.data.product_list[0].product[2].can_create = 1;
      // }
      this.product_list = res.data.product_list;
      this.my_shop = res.data.my_shop;
      let product_classify = res.data.product_list.map((item, index) => {
        return {
          index: index + 2,
          title: item.one_class_title,
        };
      });
      console.log(this.product_list,"this.product_list")
    },
    productHover(m, n) {
      this.activeLi = [m, n];
      // console.log(this.activeLi,'111')
    },
    productLeave() {
      this.activeLi = [];
    },
    createSystemTip(row) {
      console.log(this.dialogCreateShop,"this.dialogCreateShop")
      this.dialogCreateShop = true;
      this.curPro = {...row};
      console.log(row,'row')
    },
    createSystemTipClose(row) {
      this.dialogCreateShop = false;
      
    },
    async createSystem(row) {
      const { id, version_tag, shop_name } = row;
      if (id == 26 || id == 29 || id == 35 || id == 36) {
        let loading = (loading = this.$loading({
          lock: true,
          text: "系统创建中，请勿刷新页面",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        }));
        try {
          const res = await createSystem({ 
            product_id: id,
            version_tag,
            shop_name
          });

          loading.close();
          if (res.code !== 1) return this.$message.error(res.msg);

          this.$message.success("系统创建成功");
          this.getlist();
        } catch (error) {
          loading.close();
        }
      }
    },
    async toSystem(row) {
      const { domain_url, is_init, shop_id } = row;
      const mobile = localStorage.getItem("login_phone");
      let loading;
      try {
        if (is_init !== 1) {
          loading = this.$loading({
            lock: true,
            text: "店铺初始化中,请稍后....",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          const res = await initShop({ shop_id });

          loading.close();
          if (res.code !== 1) return this.$message.error(res.msg);

          this.$message.success(res.msg);
        }

        window.open(
          `http://system.${domain_url}/#/autologin?target=${mobile}&psd=${
            localStorage.getItem("login_psd") || mobile
          }`
        );
      } catch (error) {
        loading.close();
      }

      // const res  = await
    },
    // async toSystem(row) {
    //   const { product_id, is_init, shop_id } = row;
    //   console.log(row,2233)
    //   this.my_shop = [...this.my_shop];
    //   console.log(this.my_shop,"this.my_shop");
    //   const mobile = localStorage.getItem("login_phone");
    //   let loading;
    //   try {
    //     if (is_init !== 1) {
    //       loading = this.$loading({
    //         lock: true,
    //         text: "店铺初始化中,请稍后....",
    //         spinner: "el-icon-loading",
    //         background: "rgba(0, 0, 0, 0.7)",
    //       });
    //       const res = await initShop({ shop_id });

    //       loading.close();
    //       if (res.code !== 1) return this.$message.error(res.msg);
    //       this.$message.success(res.msg);
    //       this.getlist();
    //     }
    //     if (row.id == 26 || product_id == 26) {
    //       let arr = this.my_shop
    //         arr.forEach(el => {
    //           if(el.product_id == 26){
    //             let key = el.key
    //             localStorage.setItem('key',key)
    //             window.open(
    //             `http://${redirectUrl}/#/autologin?target=${mobile}&psd=${
    //               localStorage.getItem("login_psd") || "0"
    //             }&key=${key}`
    //             );
    //           }
    //         });
          
    //     }
    //     if (product_id == 29 || row.id == 29) {
    //         // const { key } = this.my_shop[0];
    //         let arr = this.my_shop
    //         arr.forEach(el => {
    //           if(el.product_id == 29){
    //             let key = el.key
    //             localStorage.setItem('key',key)
    //             window.open(
    //             `http://${redirectUrl1}#/autologin?target=${mobile}&psd=${
    //               localStorage.getItem("login_psd") || "0"
    //             }&key=${key}`
    //             );
    //           }
    //         });
            
            
    //     }

    //   } catch (error) {
    //   }
    // },
    async delshop(row) {
      await this.$confirm("确认删除该店铺", "提示", {
        confirmButtonText: "删除",
        type: "danger",
      });

      const { shop_id } = row;
      const res = await delShop({ shop_id });

      if (res.code !== 1) return this.$message.error(res.msg);

      this.getlist();
    },
  },
  mounted() {},
  created() {
    let isForget = localStorage.getItem("isForget");
    if (isForget == 1) {
      localStorage.setItem("isForget", 0);
      this.$router.push({
        name: "user_center",
        params: { showpage: 3 },
      });
    }
    this.getlist();
  },
  beforeCreate: function () {},
  components: {
    Header,
    CreateShop,
  },
};
</script>

<style lang="scss" scoped>
h5.tit {
  font-size: 24px;
  color: #333;
  text-align: left;
  // font-weight: normal;
}

.all_edition {
  margin-bottom: 26px;
  margin-top: 60px;

  ul {
    margin-top: 18px;
    display: flex;
    flex-wrap: wrap;
    li {
      width: 278px;
      height: 184px;
      background-color: #fff;
      border-radius: 10px;
      overflow: hidden;
      margin-right: 28px;
      margin-bottom: 30px;
      position: relative;
      box-shadow: 0 0 20px #e3dcdc;
      cursor: pointer;

      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 24px;

        p {
          font-size: 20px;
          color: #666;
          font-weight: bold;
          width: 170px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
        }

        img {
          width: 30px;
        }
      }

      .desc {
        font-size: 12px;
        line-height: 24px;
        color: #666;
        padding: 0 24px;
        text-align: justify;

        .textbox {
          height: 83px;
          border-bottom: 1px solid #eeeeee;
        }

        p {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
      }

      .bt {
        padding: 0 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: #666;
        height: 43px;
        margin-top: 10px;
        position: absolute;
        width: 100%;
        box-sizing: border-box;
        left: 0;
        bottom: 0;
        transition: all 0.3s ease;
      }
    }
    li:nth-child(4n) {
      margin-right: 0;
    }
    .on {
      .bt {
        background-color: #ff6454;
        color: #fff;
      }
    }
  }
}

.my_store {
  margin-top: 20px;
  background-color: #fff;
  padding: 30px 0 30px;

  // margin-bottom: 60px;
  ul {
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;

    li {
      width: 278px;
      height: 250px;
      background-color: #f4f4f4;
      border-radius: 10px;
      font-size: 14px;
      overflow: hidden;
      margin-right: 28px;
      margin-bottom: 30px;
      text-align: center;
      cursor: pointer;

      .icon {
        width: 70px;
        height: 70px;
        margin: 24px auto 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      img {
        width: 100%;
      }

      h6 {
        font-size: 20px;
        margin-top: 18px;
        text-align: center;
        font-weight: normal;
        color: #333;
      }

      .info {
        width: 184px;
        height: 40px;
        background-color: #fff;
        border-radius: 25px;
        margin: 10px auto 0;
        display: flex;
        align-items: center;
        justify-content: center;

        em {
          width: 3px;
          height: 15px;
          background-color: #9f9f9f;
          margin: 0 9px;
        }

        .time {
          color: #ff5543;
        }
      }

      .del {
        color: #666;
        margin: 17px auto 0;
        display: inline-block;
        cursor: pointer;
      }
    }
    li:nth-child(4n) {
      margin-right: 0;
    }
  }
}
</style>